import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ full_name: "", email: "", password: "" });
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await register(form.full_name, form.email, form.password);
      toast.success("Account created");
      navigate("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not create account");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="px-6 py-24 max-w-md mx-auto animate-in fade-in duration-500" data-testid="register-page">
      <p className="overline text-primary mb-4">Account</p>
      <h1 className="editorial-heading text-4xl md:text-5xl text-secondary mb-3">Create account</h1>
      <p className="text-muted-foreground mb-10 text-sm">
        Faster checkouts. Order history. Direct COA access.
      </p>
      <form onSubmit={submit} className="space-y-5">
        <div>
          <Label htmlFor="full_name">Full name</Label>
          <Input id="full_name" required value={form.full_name} onChange={(e) => setForm({ ...form, full_name: e.target.value })} data-testid="register-name" className="rounded-none mt-1.5" />
        </div>
        <div>
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="register-email" className="rounded-none mt-1.5" />
        </div>
        <div>
          <Label htmlFor="password">Password</Label>
          <Input id="password" type="password" minLength={6} required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="register-password" className="rounded-none mt-1.5" />
        </div>
        <Button
          type="submit"
          disabled={submitting}
          data-testid="register-submit"
          className="w-full rounded-none bg-secondary text-secondary-foreground hover:bg-primary hover:text-primary-foreground uppercase tracking-[0.22em] text-xs py-6"
        >
          {submitting ? "..." : "Create account"}
        </Button>
      </form>
      <p className="text-sm text-muted-foreground mt-8 text-center">
        Already have an account?{" "}
        <Link to="/login" className="text-secondary underline underline-offset-4 hover:text-primary" data-testid="register-to-login">
          Sign in
        </Link>
      </p>
    </div>
  );
}
